import {createStore, combineReducers, applyMiddleware, compose} from 'redux';
import ReduxThunk from 'redux-thunk';

import agencyReducer from './agency';
import property from './property';
import properties from './properties';
import form from './form';
import user from './user';
import files from './files';

const reducers = combineReducers({
  agency: agencyReducer,
  property,
  properties,
  form,
  user,
  files,
});

const rootReducer = (state, action) => {
  if (action.type === 'RESET') {
    return reducers(undefined, action);
  }
  return reducers(state, action);
};

const middleware = [
  applyMiddleware(ReduxThunk),
  ...(window.__REDUX_DEVTOOLS_EXTENSION__
    ? [window.__REDUX_DEVTOOLS_EXTENSION__()]
    : []),
];

const configureStore = () => {
  const store = createStore(rootReducer, {}, compose(...middleware));

  return store;
};

export default configureStore;
